import { parseISO, format } from 'date-fns';

// Based off https://stackoverflow.com/questions/4187146/truncate-number-to-two-decimal-places-without-rounding
function truncateToNDecimalPlaces(num: number, n: number) {
  const re = new RegExp(`^-?\\d+(?:\\.\\d{0,${n || -1}})?`);
  return Number(num.toString().match(re)?.[0]);
}

function truncateTo2DecimalPlaces(num: number) {
  return truncateToNDecimalPlaces(num, 2);
}

export const formatDate = (input: string | Date) => {
  let dateInput = input;
  if (typeof input === 'string') {
    dateInput = parseISO(input) as Date;
  }
  return format(dateInput as Date, 'do MMM yyyy');
};

export const formatCurrencySymbol = (currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).formatToParts(4242)[0].value;
};

export const formatCountryRegion = (region: string) => {
  return new Intl.DisplayNames(['en'], { type: 'region' }).of(region);
};

export const formatPrice = (price: number, currency: string) => {
  if (!Number.isNaN(price)) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency })
      .format(truncateTo2DecimalPlaces(price))
      .replace(/^(\D+)/, '$1 ')
      .replace(/\s+/, ' ');
  }

  return '--';
};
